// 通过控制元素的是否禁用，防止用户在一段时间内不可点击，从而防止重复点击
export default {
    mounted(el, binding) {
        el.addEventListener('click', () => {
            if (!el.disabled) {
                el.disabled = true
                setTimeout(() => {
                    el.disabled = false
                }, binding.value || 1000)
            }
        })
    }
}